function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/application/star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1u70f8vzka"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/star (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/star (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/star",
    style: {
      clipPath: "url(#1u70f8vzka)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/star (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/star (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.007 5.563-4.959-.721L8.832.348a.625.625 0 0 0-1.121 0L5.494 4.842l-4.959.721a.625.625 0 0 0-.346 1.066l3.588 3.5-.848 4.939a.624.624 0 0 0 .906.658l4.436-2.332 4.436 2.332a.625.625 0 0 0 .906-.658l-.848-4.939 3.588-3.5a.626.626 0 0 0-.346-1.066z",
    transform: "translate(1.729 1.334)",
    style: {
      fill: "#b4e138"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteNone);
export default __webpack_public_path__ + "static/media/favorite_none.9338bfe53e3645e10f0d10b791b5824e.svg";
export { ForwardRef as ReactComponent };